import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { RevisionSearchRequest } from '../../../models/net/request/revision-search-request';
import { Observable } from 'rxjs';
import { HttpFactory } from '../../../utilities/http-factory';
import { RevisionSearchResult } from '../../../models/net/result/revision-search-result';
import { ReadResult } from '../../../models/net/result/crud/read-result';
import { ScrudgService } from '../scrudg/scrudg.service';

@Injectable({
    providedIn: 'root'
})

export class ScrudgRevisionService extends ScrudgService {

    public constructor (public override http: HttpClient, @Inject("API_BASE_URL") apiBaseUrl: string, @Inject("") controllerName: string) {

        super(http, apiBaseUrl, controllerName);
    }

    public searchRevisions(request: RevisionSearchRequest): Observable<RevisionSearchResult[] | null> {

        const result = HttpFactory.post<RevisionSearchResult[]>(this.http, request, this._controllerName + "/revision/search", this._apiBaseUrl);

        return result;
    }

    public readRevision(itemId: number, revisionNumber: number): Observable<ReadResult | null> {

        const result = HttpFactory.get<ReadResult>(this.http, this._controllerName + "/revision/read/" + itemId.toString() + "/" + revisionNumber.toString(), this._apiBaseUrl);

        return result;
    }
}
